import React, { FC, useEffect, useState } from 'react';
import { makeStyles } from 'tss-react/mui';
import { useIntl } from 'react-intl';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, FormHelperText } from '@mui/material';
import { useHistory } from 'react-router-dom';
import { useJWT } from '@/app/common/utils';
import { RootState, useProjectDispatch, useProjectSelector } from 'src/redux/store';
import { setSelectRoleAdActing } from '../../ActivityManagement/redux/selected-role-redux';
import { useSelector } from 'react-redux';
import { TokenInfo } from '../../Auth/types/auth-types';

const useStyles = makeStyles()((theme) => ({
  root: {
    fontSize: 20,
    fontWeight: 'bold',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  footerContainer: {
    display: 'flex',
    justifyContent: 'end',
    alignItems: 'center',
    padding: '0',
  },
  container: {
    paddingBottom: 10,
    paddingRight: 20,
    width: '420px',
  },
  btn: {
    color: '#FFFFFF',
    textTransform: 'uppercase',
    fontWeight: 'bold',
    backgroundColor: '#BABABA',
  },
  roleBg: {
    backgroundColor: '#4386E5',
  },
  errorText: {
    fontSize: 12,
    fontWeight: 400,
    fontFamily: 'Poppins',
    color: '#F018A6',
    margin: '10px 0 0 20px',
  },
}));

const LandingPage: FC = () => {
  const { classes } = useStyles();
  // const dispatch = useProjectDispatch();
  const intl = useIntl();
  const Translation = (id: string) => intl.formatMessage({ id });
  // const history = useHistory();

  // const [onOpen, setOpen] = useState(false);
  // const [roles, setRole] = useState<string[]>([]);
  // const [selectedRole, setSelectRole] = useState('');
  // const [isError, setError] = useState(false);
  // const roleAdList = (useJWT() as any)?.roleAdList as string[];

  // const roleAdActing = useProjectSelector((state) => state.selectedRole.roleAdActing);
  // console.log(roleAdActing);
  // const tempRole = useSelector<RootState, any>((state) => state);

  // console.log(tempRole);
  // const _user = useSelector<RootState, TokenInfo>((state) => state.auth.user as TokenInfo);
  // console.log(_user);
  // console.log(history);

  // const closeDialog = (isCancel: boolean) => {
  //   setOpen(false);
  //   if (isCancel) {
  //     history.push('/logout');
  //   }
  // };

  // const setRoleAdActing = () => {
  //   setError(selectedRole == '' || selectedRole === undefined);
  //   if (!(selectedRole == '' || selectedRole === undefined)) {
  //     dispatch(setSelectRoleAdActing(selectedRole));
  //     closeDialog(false);
  //   }
  // };

  // useEffect(() => {
  //   setRole(roleAdList);
  // }, [roleAdList]);

  // useEffect(() => {
  //   if (roleAdActing) {
  //     setSelectRole(roleAdActing);
  //   }
  //   if (!isError) return;
  //   if (selectedRole == '' || selectedRole === undefined) {
  //     setError(true);
  //   } else {
  //     setRoleAdActing();
  //   }
  // }, [selectedRole, roleAdActing]);

  // useEffect(() => {
  //   if (roles?.length == 1) {
  //     setSelectRole(roles?.[0]);
  //     setRoleAdActing();
  //   }
  //   setOpen((roles?.length > 1 && selectedRole == '') || selectedRole === undefined);
  // }, [roles]);

  // const SelectRole = ({}) => {
  //   return (
  //     <div className={classes.container}>
  //       <DialogContent>
  //         {roles.map((roleName, index) => (
  //           <Button
  //             key={`${roleName}-${index}`}
  //             className={`${classes.btn} ${classes.roleBg}`}
  //             variant="contained"
  //             style={{ marginLeft: 20 }}
  //             onClick={() => setSelectRole(roleName)}
  //           >
  //             {roleName}
  //           </Button>
  //         ))}
  //         <FormHelperText className={`Mui-error ${classes.errorText}`}>
  //           {isError && Translation('activity.plan.monthly.select-role.require')}
  //         </FormHelperText>
  //       </DialogContent>
  //       <DialogActions>
  //         <div className={classes.footerContainer}>
  //           {/* todo: cancel warling */}
  //           <Button
  //             style={{ marginLeft: 20 }}
  //             variant="contained"
  //             color="secondary"
  //             onClick={() => {
  //               closeDialog(true);
  //             }}
  //           >
  //             {Translation('app.button.cancel')}
  //           </Button>
  //           <Button
  //             style={{ marginLeft: 20 }}
  //             className={`${classes.btn} ${classes.roleBg}`}
  //             variant="contained"
  //             onClick={setRoleAdActing}
  //           >
  //             {Translation('app.button.submit')}
  //           </Button>
  //         </div>
  //       </DialogActions>
  //     </div>
  //   );
  // };

  return (
    <div className={classes.root}>
      {Translation('landing.title')}
      {/* <Dialog open={onOpen}>
        <DialogTitle>{'Select Role'}</DialogTitle>
        <SelectRole />
      </Dialog> */}
    </div>
  );
};

export default LandingPage;
